import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
const styles = {
    base: [
        // base
        'px-8 py-4 rounded'
    ],
    type: {
        error: {
            boxStyle: 'bg-red-50 border border-red-200',
            mainTextStyle: 'text-red-800',
            titleTextStyle: 'text-red-900'
        },
        info: {
            boxStyle: 'bg-blue-50 border border-blue-200',
            mainTextStyle: 'text-blue-800',
            titleTextStyle: 'text-blue-900'
        },
        success: {
            boxStyle: 'bg-green-50 border border-green-200',
            mainTextStyle: 'text-green-800',
            titleTextStyle: 'text-green-900'
        },
        warning: {
            boxStyle: 'bg-yellow-50 border border-yellow-200',
            mainTextStyle: 'text-yellow-800',
            titleTextStyle: 'text-yellow-900'
        }
    }
};
export function MessageBox({ className, message, title, type = 'info', ...props }) {
    const typeStyles = styles.type[type];
    return /*#__PURE__*/ _jsxs("div", {
        className: twMerge([
            styles.base,
            typeStyles.boxStyle,
            className
        ]),
        ...props,
        children: [
            title && /*#__PURE__*/ _jsx("p", {
                className: twMerge([
                    typeStyles.titleTextStyle,
                    'font-bold mb-1'
                ]),
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: twMerge([
                    typeStyles.mainTextStyle,
                    'text-sm'
                ]),
                children: message
            })
        ]
    });
}
